<template lang="pug">
transition(name="slide-down")
  .absolute.end-5.top-7.z-40.rounded-xl(v-show="isIOSSafari && !isInStandaloneMode && isShow", ref="clickOutsideContainer", class="portrait:inset-0 portrait:flex portrait:items-center portrait:rounded-none bg-black/80", @click.stop="clickOutside")
    .w-72.mx-auto.rounded-xl.relative
      button.absolute.-top-2.-end-2.bg-white.text-gray-500.rounded-full.p-1.shadow-md.z-50.flex.items-center.justify-center(@click.stop="clickOutside")
        svg.w-4.h-4(fill="none", stroke="currentColor", viewBox="0 0 24 24", xmlns="http://www.w3.org/2000/svg")
          path(stroke-linecap="round", stroke-linejoin="round", stroke-width="2", d="M6 18L18 6M6 6l12 12")
      .shadow-xl.rounded-xl.text-center(class="bg-[#f8f8f8]/[0.82]")
        .px-4.py-2
          .title Add to Home Screen
          p.text-xs.text-gray-500 Install our PWA to get better user experience.
        .border-t.border-gray-200.px-2.text-xs
          .flex.text-blue-500
            .flex-1.border-e.border-gray-200.pt-2.pb-2.relative
              .rounded-full.bg-white.w-10.m-auto.p-2.shadow-lg.mb-1
                img.w-8.mx-auto(src="assets/images/common/icon-ios-share.svg")
              p Share
              .absolute.start-0.top-0.ms-2.mt-1.text-gray-500 1
            .flex-1.border-e.border-gray-200.pt-2.pb-2.relative
              .rounded-full.bg-white.w-10.m-auto.p-2.shadow-lg.mb-1
                img.w-8.ms-auto(src="assets/images/common/icon-ios-install.svg")
              p Add
              .absolute.start-0.top-0.ms-2.mt-1.text-gray-500 2
            .flex-1.pt-2.pb-2.relative
              .rounded-full.bg-white.w-10.m-auto.shadow-lg.mb-1
                img.mx-auto.rounded-xl.shadow-xl(:src="getBackCdnUrl('icon/logo_square_icon.png')")
              p Done
              .absolute.start-0.top-0.ms-2.mt-1.text-gray-500 3
</template>

<script setup>
import { ref, computed } from 'vue'

const { getBackCdnUrl } = useCdnAssets()

const isShow = ref(true)

// 檢測 iOS Safari（結合 UA 和特性檢測）
const isIOSSafari = computed(() => {
  if (typeof window === 'undefined') return false

  const ua = navigator.userAgent
  // iPad OS 13+ 會偽裝成 Mac，需要用 maxTouchPoints 檢測
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

  // Safari 特有：有 Safari 但沒有其他瀏覽器標識（iOS 上的 Chrome/Firefox/Edge 都包含 Safari 字串）
  const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(ua)

  return isIOS && isSafari
})

const isInStandaloneMode = computed(() => {
  if (typeof window === 'undefined') return false
  return 'standalone' in window.navigator && window.navigator.standalone
})

const clickOutside = () => {
  isShow.value = false
}
</script>

<style lang="scss" scoped>
.instruction-iOS {
  background-image: url('assets/images/common/pwadl_img_landscape_en.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  inset-inline-end: calc(env(safe-area-inset-right) + 0.625rem);
}
</style>
